import { PERMISSIONS } from "context/auth/types";

const getPermissionCheckState = (
    permissions: PERMISSIONS[],
    checkedPermissions: PERMISSIONS[]
) => {
    const checkedCount = checkedPermissions.length;

    return {
        isAll: checkedCount === permissions.length,
        isPartial: checkedCount > 0 && checkedCount < permissions.length,
        isAtLeastOne: checkedCount > 0,
        isNone: checkedCount === 0
    };
};

export { getPermissionCheckState };
